import { FinancingSimulator } from 'components/FinancingSimulator';
import { handleSimulatorPMT } from 'components/FinancingSimulator/utils';
import Button from 'components/Form/Button';
import FormCore from 'components/Form/Core';
import LandDistribuidores from 'containers/LandPageDist';
import { CoreContext } from 'context/CoreContext';
import { useCallback, useContext, useEffect, useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
import { toast } from 'react-toastify';
import { POST, ReadAddressesByZipCode } from 'services/api';
import { Title } from 'ui/styled';
import { exposeStrapiError } from 'utils';
import { unmaskPhone } from 'utils/parsers';
import { isCpf } from 'utils/validators';
import {
  CenterLogo,
  FinancingProposalFormsWrapper,
  FormSpacing,
} from './styled';

const sendPreProposal = async (payload) => {
  try {
    const response = await POST('/pre-proposal/landcreate', payload, false);
    return response;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export default function FinancingProposalNewDist() {
  const history = useHistory();
  const navigate = useCallback((to) => history.push(`/${to}`), [history]);
  const { id } = useParams();
  const { reloadContent } = useContext(CoreContext);

  const refFormIdent = useRef();
  const refFormCliente = useRef();
  const refFormEndereco = useRef();

  const [loading, setLoading] = useState(false);
  const [tipoCliente, setTipoCliente] = useState('fisica');
  const [selectedDistribuidor, setSelectedDistribuidor] = useState('');
  const [urlLogo, setUrlLogo] = useState('');
  const [idDistrib, setidDistrib] = useState(false);
  const [installmentValue, setInstallmentValue] = useState();

  // ==================================================
  // Campos do formulário
  // ==================================================
  const pessoFisJudi = [
    { id: 'fisica', title: 'Física', name: 'Física' },
    { id: 'juridica', title: 'Jurídica', name: 'Jurídica' },
  ];

  const formIdent = [
    {
      ref: 'cnpj_integrador',
      placeholder: 'CNPJ Integrador',
      mask: '99.999.999/9999-99',
      required: true,
      tress: true,
    },
    {
      ref: 'nome_integrador',
      placeholder: 'Nome Integrador',
      required: true,
      tress: true,
      quarter: true,
    },
    {
      ref: 'telefone_vendedor',
      placeholder: 'Telefone Vendedor (integrador)',
      mask: '(99)99999-9999',
      required: true,
      tress: true,
    },
    {
      ref: 'nome_vendedor',
      placeholder: 'Nome Vendedor (integrador)',
      required: true,
      tress: true,
    },
  ];

  const formCliente = [
    {
      ref: 'tcc2',
      placeholder: 'Tipo de Pessoa',
      options: pessoFisJudi,
      required: true,
      tress: true,
      onBlur: async () => {
        const value = refFormCliente?.current?.getItem('tcc2');
        setTipoCliente(value);
      },
    },
    {
      ref: 'cpf',
      placeholder: 'CPF/CNPJ',
      type: 'cpf',
      required: true,
      tress: true,
    },
    {
      ref: 'nome_completo',
      placeholder: 'Nome Completo',
      required: true,
      tress: true,
    },
    {
      ref: 'data_nascimento',
      type: 'date',
      placeholder:
        tipoCliente === 'juridica' ? 'Data abertura' : 'Data de Nascimento',
      required: true,
      quarter: true,
    },
    {
      ref: 'valor_financiamento',
      type: 'money',
      placeholder: 'Valor da compra',
      required: true,
      quarter: true,
      onBlur: (e) => handleSimulatorPMT(e, setInstallmentValue),
    },
    {
      ref: 'celular',
      placeholder: 'Celular',
      mask: '(99)99999-9999',
      required: true,
      quarter: true,
    },
    {
      ref: 'email',
      placeholder: 'E-mail',
      type: 'email',
      required: false,
      quarter: true,
    },
  ];

  const formEndereco = [
    {
      ref: 'cep',
      placeholder: 'CEP',
      mask: '99999-999',
      quarter: true,
      required: false,
      onBlur: async (event) => {
        const cep = event.target.value.replace(/\D/g, '');
        if (cep.length === 8) {
          try {
            const data = await ReadAddressesByZipCode(cep);
            if (data && refFormEndereco.current) {
              refFormEndereco.current.setItem(
                data.logradouro || '',
                'logradouro'
              );
              refFormEndereco.current.setItem(data.bairro || '', 'bairro');
              refFormEndereco.current.setItem(data.localidade || '', 'cidade');
              refFormEndereco.current.setItem(data.uf || '', 'uf');
            }
          } catch (err) {
            console.warn('Erro ao buscar CEP:', err);
            toast.warn('CEP não encontrado.');
          }
        }
      },
    },
    {
      ref: 'logradouro',
      placeholder: 'Logradouro',
      quarter: true,
      required: false,
    },
    { ref: 'numero', placeholder: 'Número', quarter: true, required: false },
    { ref: 'complemento', placeholder: 'Complemento', quarter: true },
    { ref: 'bairro', placeholder: 'Bairro', tress: true, required: false },
    {
      ref: 'cidade',
      placeholder: 'Cidade',
      tress: true,
      required: false,
      disabled: true,
    },
    {
      ref: 'uf',
      placeholder: 'UF',
      tress: true,
      required: false,
      disabled: true,
    },
  ];

  // ==================================================
  // Formatar CPF/CNPJ
  // ==================================================
  const formatarDocumento = (valor) => {
    if (!valor) return '';
    let numeros = valor.replace(/\D/g, '');
    if (numeros.length === 11) {
      return numeros
        .replace(/^(\d{3})(\d)/, '$1.$2')
        .replace(/^(\d{3})\.(\d{3})(\d)/, '$1.$2.$3')
        .replace(/\.(\d{3})(\d)/, '.$1-$2');
    } else if (numeros.length === 14) {
      return numeros
        .replace(/^(\d{2})(\d)/, '$1.$2')
        .replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3')
        .replace(/\.(\d{3})(\d)/, '.$1/$2')
        .replace(/(\d{4})(\d)/, '$1-$2');
    }
    return numeros;
  };

  // ==================================================
  // Função para limpar todos os formulários (100% garantida)
  // ==================================================
  const limparFormularios = () => {
    // Identificação
    [
      'distribuidor',
      'cnpj_integrador',
      'telefone_vendedor',
      'nome_vendedor',
    ].forEach((campo) => {
      refFormIdent.current?.setItem?.('', campo);
    });
    // Cliente
    [
      'tcc2',
      'nome_completo',
      'cpf',
      'data_nascimento',
      'email',
      'celular',
      'valor_financiamento',
      'nome_integrador',
    ].forEach((campo) => {
      refFormCliente.current?.setItem?.('', campo);
    });
    // Endereço
    [
      'cep',
      'logradouro',
      'numero',
      'complemento',
      'bairro',
      'cidade',
      'uf',
    ].forEach((campo) => {
      refFormEndereco.current?.setItem?.('', campo);
    });
    // Volta ao topo
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  // ==================================================
  // Função de envio
  // ==================================================
  const save = async () => {
    if (loading) return;
    setLoading(true);
    const ident = refFormIdent.current?.getForm();
    const cliente = refFormCliente.current?.getForm();
    const endereco = refFormEndereco.current?.getForm();
    if (!cliente || !ident) {
      toast.error('Preencha todos os campos obrigatórios.');
      setLoading(false);
      return;
    }
    const cpfCnpjRaw = cliente.cpf || '';
    const codigoCli = formatarDocumento(cpfCnpjRaw);
    const len = codigoCli.replace(/\D/g, '').length;
    if (len !== 11 && len !== 14) {
      toast.error('O CPF/CNPJ do cliente não é válido!');
      setLoading(false);
      return;
    }
    let distribuidorId = id;
    if (!distribuidorId) {
      toast.error(
        'Distribuidor não informado. Verifique seu usuário ou selecione um distribuidor.'
      );
      setLoading(false);
      return;
    }
    if (cliente.tcc2 !== 'juridica') {
      if (!isCpf(codigoCli)) {
        toast.error('Favor informar CPF valido.');
        setLoading(false);
        return;
      }
    }
    //valida se o celular informado contem 11 digitos
    if (cliente.celular) {
      const celularLimpo = unmaskPhone(cliente.celular);
      if (celularLimpo.length < 11) {
        toast.error(
          'Favor informar um número de celular válido com 11 dígitos.'
        );
        setLoading(false);
        return;
      }
    }
    const rawData = {
      nome_completo: cliente.nome_completo?.trim() || null,
      tipo_cliente: cliente.tcc2?.trim() || null,
      [cliente.tcc2?.trim() === 'fisica' ? 'cpf' : 'cnpj']: codigoCli,
      data_nascimento: cliente.data_nascimento || null,
      email: cliente.email?.toLowerCase().trim() || null,
      valor_financiamento: cliente?.valor_financiamento,
      distribuidor: { id: parseInt(distribuidorId, 10) },
      //ddd: unmaskPhone(cliente.celular),    //pega os dois primeiros digitos como DDD
      celular: unmaskPhone(cliente.celular) || null,
      cep: endereco?.cep ? endereco.cep.replace(/\D/g, '') : null,
      logradouro: endereco?.logradouro?.trim() || null,
      numero: endereco?.numero?.trim() || null,
      complemento: endereco?.complemento?.trim() || null,
      bairro: endereco?.bairro?.trim() || null,
      cidade: endereco?.cidade?.trim() || null,
      uf: endereco?.uf?.trim() || null,
      //novos campos solicitados
      nome_vendedor: ident?.nome_vendedor?.trim() || null,
      //ddd_vendedor: unmaskPhone(cliente.telefone_vendedor)?.substring(0, 2) || null,
      telefone_vendedor: unmaskPhone(ident?.telefone_vendedor) || null,
      cnpj_integrador: ident?.cnpj_integrador || null,
      nome_integrador: ident?.nome_integrador || null,
    };

    const data = Object.fromEntries(
      Object.entries(rawData).filter(
        ([_, v]) => v !== null && v !== undefined && v !== ''
      )
    );
    const payload = { data };

    try {
      const response = await sendPreProposal(payload);
      if (response?.error || exposeStrapiError(response)) {
        const message =
          response?.error?.message || 'Erro ao enviar pré-proposta.';
        toast.error(message);
        setLoading(false);
        return;
      }
      // SUCESSO: Limpa tudo e permite novo cadastro
      toast.success('Pré-proposta enviada com sucesso! Pode cadastrar outra.');
      limparFormularios(); // ← AQUI ESTÁ O REFRESH PERFEITO
      reloadContent?.(true); // Atualiza listas/contadores
    } catch (error) {
      console.error('Erro ao enviar pré-proposta:', error);
      const message =
        error?.error?.message ||
        error?.message ||
        'Falha ao conectar com o servidor.';
      toast.error(message);
    } finally {
      setLoading(false);
    }
  };
  const toUpperCase = (str) => {
    if (!str) return '';
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  };
  // atualiza o nome do distribuidor com base no id da url
  useEffect(() => {
    switch (id) {
      case '1152':
        setSelectedDistribuidor('Fotus');
        setUrlLogo(
          'https://fotus.com.br/wp-content/uploads/2024/10/LOGO_Fotus-Track-Page-1A.png'
        );
        break;
      case '1222':
        setSelectedDistribuidor('Vertys');
        setUrlLogo('https://vertysgroup.com/uploads/site/veryss.png');
        break;
      case '1165':
        setSelectedDistribuidor('Elevo');
        setUrlLogo(
          'https://elevoenergy.com.br/wp-content/uploads/2023/02/cropped-cropped-ELEVO-LOGO-2.png'
        );
        break;
      case '1224':
        setSelectedDistribuidor('Bionova');
        setUrlLogo(
          'https://api.evontech.com.br/uploads/logo_Bionova_780f0aa255.jpeg'
        );
        break;
      case '1225':
        setSelectedDistribuidor('Energy+');
        setUrlLogo(
          'https://api.evontech.com.br/uploads/energy_logo_c52f646685.jpeg'
        );
        break;
      case '1164':
        setSelectedDistribuidor('Edeltec');
        setUrlLogo(
          'https://api.evontech.com.br/uploads/logo_edeltec_c3906ae99b.png'
        );
        break;
      case '1209':
        setSelectedDistribuidor('Envia Sol');
        setUrlLogo(
          'https://api.evontech.com.br/uploads/logo_envia_sol_verde_11c02a2427.png'
        );
        break;
      case '1227':
        setSelectedDistribuidor('JNG');
        setUrlLogo('https://api.evontech.com.br/uploads/jng_1d9bfc11ac.jpeg');
        break;
      case '1228':
        setSelectedDistribuidor('Solar21');
        setUrlLogo(
          'https://api.evontech.com.br/uploads/logo_solar21_ccbbfa3f5f.jpeg'
        );
        break;
      default:
        navigate('login');
        setSelectedDistribuidor('');
    }
    if (id !== '1222') {
      setidDistrib(true);
    }
  }, [id, navigate]);
  // ==================================================
  // Render
  // ==================================================
  return (
    <LandDistribuidores>
      <FinancingProposalFormsWrapper>
        {(() => {
          const logoUrl = urlLogo;
          return logoUrl ? (
            <CenterLogo>
              <img src={logoUrl} alt="Logo" />
            </CenterLogo>
          ) : null;
        })()}
        {(() => {
          if (!tipoCliente || tipoCliente === 'fisica') return null;
          return null;
        })()}
        <Title small nomargin>
          Formulário de Pré-Financiamento {toUpperCase(selectedDistribuidor)}
        </Title>
        <FormSpacing />
        <Title small nomargin>
          Identificação
        </Title>
        <FormCore ref={refFormIdent} formItems={formIdent} />
        <FormSpacing />
        <Title small nomargin>
          Informações do Cliente
        </Title>
        <FormCore ref={refFormCliente} formItems={formCliente} />
        <FormSpacing />

        {idDistrib && (
          <>
            <Title small nomargin>
              Endereço
            </Title>
            <FormCore ref={refFormEndereco} formItems={formEndereco} />
            <FormSpacing />
          </>
        )}
        <FinancingSimulator installmentValue={installmentValue} />
        <div
          style={{ display: 'flex', justifyContent: 'flex-start', gap: '12px' }}
        >
          <Button
            color="blue"
            width={'fit-content'}
            small
            nospace
            loading={loading}
            onClick={save}
            disabled={loading}
            onBlur={isCpf}
          >
            Enviar Pré-Proposta
          </Button>
        </div>
      </FinancingProposalFormsWrapper>
    </LandDistribuidores>
  );
}
